const PhotoCheckRequest = require('./photo_check_request.js');

const warningTypeName = 'guitars';
const route = 'guitar';
const responseAttribute = 'guitar_body';

module.exports = class ElectricGuitarsPhotoContents {
  static get productTypeUUID() {
    return 'dfd39027-d134-4353-b9e4-57dc6be791b9';
  }

  constructor(photo, imageDetectionPath) {
    this.photo = photo;
    this.imageDetectionPath = imageDetectionPath;
  }

  checkPhoto() {
    return new PhotoCheckRequest(
      this.photo, 
      this.imageDetectionPath, 
      route, 
      responseAttribute, 
      warningTypeName).checkPhoto();
  }
};



// WEBPACK FOOTER //
// ./javascripts/components/photos/contents/electric_guitars.js